module.exports = __webpack_public_path__ + "static/targeted-ea53bebc0a92d4adcb3b9bd9db4b68c4.jpg";